import { render } from "./News.vue?vue&type=template&id=293a9583"
import script from "./News.vue?vue&type=script&setup=true&lang=js"
export * from "./News.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/News.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "293a9583"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('293a9583', __exports__)) {
    api.reload('293a9583', __exports__)
  }
  
  module.hot.accept("./News.vue?vue&type=template&id=293a9583", () => {
    api.rerender('293a9583', render)
  })

}


export default __exports__